<div class="definitions-editor-conatiner">
  <opath-core-nav-header
    #header
    [title]="translation?.title"
    [height]="100"
    [buttons]="hedaerButtons"
    (onFilterOptionChanged)="filterOptionChanged($event)"
    (onSearchTermChanged)="searchTermChanged($event)"
  >
  </opath-core-nav-header>
  <div class="parameter-definitions">
    <abc-scroll-view>
      <abc-list
        [dataSource]="parameterDefinitions"
        [focusStateEnabled]="false"
        [activeStateEnabled]="false"
        [searchValue]="searchTerm"
        [searchExpr]="'Caption'"
        [searchMode]="currentFilterOption?.searchMode ?? 'contains'"
      >
        <div style="padding: 0px" *dxTemplate="let parameter of 'item'">
          <div class="definitions" *ngIf="currentParameterDefinitions[0] !== parameter; else edit">
            <abc-button
              [width]="'100%'"
              [height]="'20px'"
              [icon]="parameter.IsUserCreated ? ' dx-icon-unlock' : ' dx-icon-lock'"
              [text]="parameter.Caption?.length ? parameter.Caption : parameter.Name"
              [toolTipContent]="
                (parameter.Caption?.length ? parameter.Caption : parameter.Name) + ' = $' + parameter.Name
              "
              [class.user-created-parameter]="parameter.IsUserCreated"
              (onClick)="selectParameter(parameter.Name)"
            ></abc-button>
            <div *ngIf="parameter.IsUserCreated" class="parameter-controls">
              <abc-button
                icon="edit"
                (onClick)="editParameter(parameter.Name)"
                [disabled]="currentParameterDefinitions.length"
                [toolTipContent]="translation?.edit"
              ></abc-button>
              <abc-button
                icon="trash"
                [toolTipContent]="translation?.delete"
                (onClick)="deleteParameter(parameter.Name)"
              ></abc-button>
            </div>
          </div>
          <ng-template #edit>
            <abc-accordion
              [dataSource]="currentParameterDefinitions"
              [collapsible]="true"
              [multiple]="false"
              [animationDuration]="300"
            >
              <div *dxTemplate="let parameter of 'title'">
                <p>{{ translation?.edit + ': ' + (parameter.Caption?.length ? parameter.Caption : parameter.Name) }}</p>
              </div>
              <div *dxTemplate="let parameter of 'item'">
                <parameters-definitions-editor-container
                  *ngIf="!loading"
                  [initialized]="true"
                  [objectTypesInfo]="objectTypesInfo"
                  [pickListByNameDataSource]="pickListByNameDataSource"
                  [pickListByColumnDataSource]="pickListByColumnDataSource"
                  [parameterDefinition]="parameter"
                  [parameterDefinitions]="parameterDefinitions"
                  [cancelChanges]="cancelChanges"
                  [saveChanges]="saveChanges"
                ></parameters-definitions-editor-container>
              </div>
            </abc-accordion>
          </ng-template>
        </div>
      </abc-list>
      <abc-accordion
        *ngIf="currentParameterDefinitions.length && !parameterDefinitions.includes(currentParameterDefinitions[0])"
        [(dataSource)]="currentParameterDefinitions"
        [collapsible]="true"
        [multiple]="false"
        [animationDuration]="300"
      >
        <div *dxTemplate="let parameter of 'title'">
          <p>{{ translation?.newParameter }}</p>
        </div>
        <div *dxTemplate="let parameter of 'item'">
          <parameters-definitions-editor-container
            *ngIf="!loading"
            [objectTypesInfo]="objectTypesInfo"
            [pickListByNameDataSource]="pickListByNameDataSource"
            [pickListByColumnDataSource]="pickListByColumnDataSource"
            [parameterDefinition]="parameter"
            [parameterDefinitions]="parameterDefinitions"
            [cancelChanges]="cancelChanges"
            [saveChanges]="saveChanges"
          ></parameters-definitions-editor-container>
        </div>
      </abc-accordion>
    </abc-scroll-view>
  </div>
</div>
